import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.style),
    class: _normalizeClass([{
      [_ctx.classNameActive]: _ctx.enabled,
      [_ctx.classNameDragging]: _ctx.dragging,
      [_ctx.classNameDraggable]: _ctx.draggable,
    }, _ctx.className]),
    ref: "eleRef",
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.elementMouseDown && _ctx.elementMouseDown(...args))),
    onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.elementTouchDown && _ctx.elementTouchDown(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 38))
}